<template>
  <div class="detail-info">
    <div class="info">
      <div class="info-top">
        <span :class="`status-icon status-icon-${detail.orderStatus}`">{{
          $getDictLabel('OMS_PLC_ORDER_STATUS', detail.orderStatus)
        }}</span>
        <span class="orderCode"> 订单编号:{{ detail.orderCode }} </span>
        <Copyable v-if="detail.orderCode" :text="detail.orderCode" />
      </div>
      <div class="info-center">
        <div><span>下单时间：</span>{{ detail.createTime }}</div>
        <div><span>下单人：</span>{{ detail.createUserName }}</div>
        <div><span>中控合同编号：</span>{{ detail.contractNo }}</div>
      </div>
      <div>
        <el-button
          v-if="detail.viewCancelOrder"
          @click="cancelOrder"
          class="plc-btn"
          size="mini"
          type="warning"
          plain
          >取消订单</el-button
        >
        <!-- <el-button v-if="detail.viewCancelOrder" @click="toEdit" class="plc-btn" size="mini" type="primary">编辑订单</el-button> -->
        <el-button
          v-if="detail.viewSubmitOrder"
          @click="submitOrder"
          class="plc-btn"
          size="mini"
          type="primary"
          >提交订单</el-button
        >
        <el-button
          v-if="detail.viewSignOrderContract"
          @click="signOrderContract"
          class="plc-btn"
          size="mini"
          type="primary"
          >去签署合同</el-button
        >
        <el-button
          v-if="detail.viewCancelSignOrderContract"
          @click="cancelSignOrderContract"
          class="plc-btn"
          size="mini"
          type="primary"
          >取消签署合同</el-button
        >
        <el-button
          v-if="detail.contractFile"
          class="plc-btn"
          @click="showContract"
          size="mini"
          type="primary"
          >查看合同</el-button
        >
      </div>
    </div>
    <div :class="`step step-${detail.orderStatus}`">
      <div class="line-wrap">
        <div class="line half"></div>
        <div class="active-line"></div>
      </div>
      <div class="step-list">
        <div
          class="step-item active"
          :class="{
            right: ['2', '3', '4'].includes(detail.orderStatus)
          }"
        >
          <span>提交订单</span>
          <span class="num">1</span>
        </div>
        <div
          class="step-item"
          :class="{
            active: ['2', '3', '4'].includes(detail.orderStatus),
            right: ['3', '4'].includes(detail.orderStatus)
          }"
        >
          <span>签署合同</span>
          <span class="num">2</span>
        </div>
        <div
          class="step-item"
          :class="{
            active: ['3', '4'].includes(detail.orderStatus),
            right: ['3'].includes(detail.orderStatus)
          }"
        >
          <span>成功提交订单</span>
          <span class="num">3</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Copyable from '@/components/copyable.vue'

export default {
  props: {
    active: {
      type: Number,
      default: 1
    },
    detail: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    Copyable
  },
  methods: {
    cancelOrder () {
      this.$confirm(`确定要取消订单吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const obj = {
          orderCode: this.detail.orderCode
        }
        this.$http
          .post('/front/oms/plc/user/cancelOrder', obj)
          .then(({ data: res }) => {
            if (res.code === 0) {
              this.$message.success('操作成功')
              this.$emit('refresh')
            }
          })
      })
    },
    submitOrder () {
      this.$confirm(`确定要提交订单吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const obj = {
          orderCode: this.detail.orderCode
        }
        this.$http
          .post('/front/oms/plc/user/submitOrder', obj)
          .then(({ data: res }) => {
            if (res.code === 0) {
              this.$message.success('操作成功')
              this.$emit('refresh')
            }
          })
      })
    },
    signOrderContract () {
      this.$confirm(`确定要发起签署合同吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const obj = {
          orderCode: this.detail.orderCode
        }
        this.$http
          .post('/front/oms/plc/user/signOrderContract', obj)
          .then(({ data: res }) => {
            if (res.code === 0) {
              this.$message.success('操作成功')
              this.$emit('refresh')
            }
          })
      })
    },
    cancelSignOrderContract () {
      this.$confirm(`确定要取消签署合同吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const obj = {
          orderCode: this.detail.orderCode
        }
        this.$http
          .post('/front/oms/plc/user/cancelSignOrderContract', obj)
          .then(({ data: res }) => {
            if (res.code === 0) {
              this.$message.success('操作成功')
              this.$emit('refresh')
            }
          })
      })
    },
    toEdit () {
      this.$router.push({
        path: '/plcOrderAdd',
        query: {
          id: this.$route.query.id
        }
      })
    },
    showContract () {
      if (this.detail.contractFile && this.detail.contractFile.url) {
        window.open(this.detail.contractFile.url)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.detail-info {
  padding: 20px 41px 20px 29px;
  background: #fff;
  margin-top: 16px;
  border-radius: 12px;
  display: flex;
}
.info {
  flex: 1;
  .info-top {
    display: flex;
    align-items: center;
    padding-bottom: 16px;
    .status-icon {
      display: block;
      border-radius: 4px;
      border: 1px solid #ff4c2b;
      font-size: 14px;
      color: #ff4c2b;
      padding: 2.5px 11px;
      &.status-icon-2 {
        border-color: #bb8f37;
        color: #bb8f37;
      }
      &.status-icon-3 {
        border-color: #2a54d1;
        color: #2a54d1;
      }
      &.status-icon-4 {
        border-color: #229f37;
        color: #229f37;
      }
      &.status-icon-5 {
        border-color: #7b7b7b;
        color: #7b7b7b;
      }
    }
    .orderCode {
      font-size: 16px;
      font-weight: bold;
      color: #000000;
      padding-left: 12px;
    }
  }
  .info-center {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #8c8c8c;
    padding-bottom: 16px;
    > div {
      padding-right: 28px;
    }
    span {
      color: #000;
    }
  }
}
.step {
  width: 518px;
  padding: 35px 0 0;
  .line-wrap {
    position: relative;
    .line {
      width: 100%;
      height: 7px;
      border-radius: 11px;
      opacity: 0.1;
      background: linear-gradient(270deg, #2a54d1 0%, #5b85ff 100%);
    }
    .active-line {
      position: absolute;
      width: 15%;
      height: 7px;
      left: 0;
      top: 0;
      border-radius: 12.87px;
      background: #2a54d1;
      z-index: 9;
    }
  }

  &.step-2 {
    .active-line {
      width: 50%;
    }
  }
  &.step-3,
  &.step-4 {
    .active-line {
      width: 100%;
    }
  }

  .step-list {
    display: flex;
    justify-content: space-around;
    padding-top: 26px;
  }
  .step-item {
    position: relative;
    font-size: 18px;
    font-weight: bold;
    text-align: center;
    color: #666666;
    &.active {
      color: #333333;
      .num {
        color: #fff;
        background: linear-gradient(315deg, #2a54d1 0%, #5b85ff 100%);
        border: 2px solid rgba(255, 255, 255, 0.5);
        box-shadow: 0px 1.84px 7.36px 0px rgba(42, 84, 209, 0.5);
      }
    }

    .num {
      position: absolute;
      left: calc(50% - 21px);
      top: -52px;
      display: block;
      width: 43px;
      height: 43px;
      line-height: 39px;
      border-radius: 50%;
      color: #999999;
      font-weight: 700;
      background: #e1e3e6;
      box-sizing: border-box;
      border: 2px solid rgba(255, 255, 255, 0.5);
      box-shadow: 0px 1.84px 3.68px 0px rgba(153, 153, 153, 0.2);
      z-index: 99;
    }
    &.right .num {
      width: 66px;
      height: 66px;
      left: calc(50% - 33px);
      top: -63px;
      background: url('~@/assets/img/plc/right.png') no-repeat center;
      background-size: cover;
      box-shadow: none;
      border: 0;
      font-size: 0;
    }
  }
}
</style>
